import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { logIn } from 'app/store/login/logged-user/logged-user.actions';
import { LoggedUserState } from 'app/store/login/logged-user/logged-user.state';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LoginComponent {
  loginForm = new UntypedFormGroup({
    username: new UntypedFormControl('', Validators.required),
    password: new UntypedFormControl('', Validators.required),
  });

  constructor(private store$: Store<LoggedUserState>) {
  }

  login(): void {
    if (!this.loginForm.valid) {
      return;
    }

    this.store$.dispatch(logIn(this.loginForm.value));
  }
}
